<template lang="pug">
  .search-input-with-delete
    el-input(
      :placeholder="$t(placeholder)"
      v-model="keyword"
      @keyup.enter.native="handleSearch"
    )
      i(
        v-show="keyword !== ''"
        slot="suffix"
        class="el-input__icon el-icon-circle-close"
        style="cursor: pointer"
        @click="handleClearInput"
      )
      i(
        slot="suffix"
        class="el-input__icon el-icon-search"
        style="cursor: pointer"
        @click="handleSearch"
      )
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default () {
        return ''
      }
    }
  },
  data () {
    return {
      keyword: '',
      searchedKeyword: ''
    }
  },
  methods: {
    handleSearch () {
      this.searchedKeyword = this.keyword
      this.$emit('handleSearch', this.keyword)
    },
    handleClearInput () {
      this.keyword = ''
      if (this.searchedKeyword !== '') {
        this.$emit('handleSearch', '')
      }
    }
  }

}
</script>

<style lang="stylus">
  .el-icon-search
    font-size 16px
    width 20px
  .el-icon-circle-close
    vertical-align top
    width 12px
</style>
